module.exports = __webpack_public_path__ + "assets/images/rbyearend-05.jpg?v=6dc5c3d0";